import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SharedContentCategory } from 'src/app/Modules/settings/enums/shared-content-category.enum';
import { SharedContentModel } from 'src/app/Modules/settings/models/general/shared-content-model';
import { ManagementApiService } from 'src/app/services';
import { SettingValueModel } from 'src/app/Modules/settings/models/informate';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TranslocoService } from '@jsverse/transloco';
import { UserUtilityService } from 'src/app/services/user-utility.service';

@Component({
    selector: 'app-landing-heros',
    templateUrl: './landing-heros.component.html',
    styleUrls: ['./landing-heros.component.scss'],
    standalone: false
})
export class LandingHerosComponent implements OnInit {
    heroImageList: SharedContentModel[];
    language: SettingValueModel;

    constructor(
        private managementApiService: ManagementApiService,
        private cd: ChangeDetectorRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private translocoService: TranslocoService,
        private user_utlity: UserUtilityService
    ) {
        this.heroImageList = [];
    }

    ngOnInit(): void {
        this.getLandingHeroImages();
    }

    // * api call to get the landing hero images
    async getLandingHeroImages() {
        this.ngxUiLoaderService.start();
        let language = 'en';
        if (this.translocoService.getAvailableLangs().some((language) => language == navigator.language.split('-')[0])) {
            // * Displaying Hero images based on the their browser language/locale
            language = navigator.language.split('-')[0];
        }
        // * getting hero images
        await this.managementApiService
            .getSharedContentForLandingPage(SharedContentCategory.HeroImages, language)
            .toPromise()
            .then(
                (res) => {
                    if (res.success === true) {
                        this.heroImageList = res.response.filter((item) => item.imageLocation == 2 || item.imageLocation == 3);
                        this.cd.detectChanges();
                        this.ngxUiLoaderService.stop();
                    } else {
                        this.ngxUiLoaderService.stop();
                        this.user_utlity.errorModelPopup(res.message);
                    }
                },
                (error) => {
                    this.ngxUiLoaderService.stop();
                    //  TODO: We can display the error toast here
                }
            );
    }

    navigateToPage(heroImageData: SharedContentModel) {
        window.open(heroImageData.navigationLink, '_blank');
    }
}
